import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './About.css';
// Icons for philosophy
import { FaLightbulb, FaRocket, FaHandshake } from 'react-icons/fa';
import AnimatedOnScroll from '../components/AnimatedOnScroll';
import profileImage from '../assets/anjoom.jpg';

// On-load animation for the header
const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const About = () => {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      exit={{ opacity: 0 }}
      style={{ paddingTop: '100px' }} // Offset for navbar
    >
      {/* 1. Hero Section */}
      <section className="container about-hero-personal">
        <motion.div variants={itemVariants} className="hero-image-personal">
          {/* You can replace this with a real photo of yourself */}
          <img src={profileImage} alt="Mohammed Anjoom, Founder" />
        </motion.div>
        <div className="hero-text-personal">
          <motion.h1 variants={itemVariants}>
            Hi, I'm Mohammed Anjoom
          </motion.h1>
          <motion.h2 variants={itemVariants} className="hero-subtitle-personal">
            Founder & Full-Stack Developer at <span className="highlight-primary">Apexio Labs</span>
          </motion.h2>
          <motion.p variants={itemVariants} style={{ transitionDelay: '0.1s' }}>
            I started Apexio Labs as a way to bring my passion for clean code,
            pixel-perfect design, and powerful backend logic directly to clients.
            When you work with Apexio Labs, you're working directly with me.
          </motion.p>
        </div>
      </section>

      {/* 2. My Philosophy Section */}
      <section className="container philosophy-section">
        <AnimatedOnScroll>
          <h2 className="section-title">My Philosophy</h2>
        </AnimatedOnScroll>
        <AnimatedOnScroll delay={0.1}>
          <p className="section-subtitle">
            I believe in a different kind of client relationship.
          </p>
        </AnimatedOnScroll>

        <div className="philosophy-grid">
          <AnimatedOnScroll className="philosophy-card">
            <FaHandshake className="philosophy-icon" />
            <h3>Direct Partnership</h3>
            <p>No project managers or middlemen. You get direct access to me, the person
              actually designing and building your project, from start to finish.</p>
          </AnimatedOnScroll>
          <AnimatedOnScroll className="philosophy-card" delay={0.1}>
            <FaLightbulb className="philosophy-icon" />
            <h3>Transparent Process</h3>
            <p>I believe in total transparency. You'll be involved in every step,
              from the first wireframe to the final deployment, with no surprises.</p>
          </AnimatedOnScroll>
          <AnimatedOnScroll className="philosophy-card" delay={0.2}>
            <FaRocket className="philosophy-icon" />
            <h3>Quality over Quantity</h3>
            <p>I'm not a high-volume agency. I take on a limited number of
              projects at a time to ensure your work gets the full focus and
              quality it deserves.</p>
          </AnimatedOnScroll>
        </div>
      </section>

      {/* 3. Call to Action Section */}
      <section className="cta-section-about">
        <AnimatedOnScroll className="container cta-container-about">
          <h2>Let's build something together.</h2>
          <p>
            Ready to get started? See what I can do for you, or get in touch
            to discuss your idea.
          </p>
          <div className="cta-buttons-about">
            <Link to="/services" className="btn" data-hover>My Services</Link>
            <Link to="/contact" className="btn btn-secondary" data-hover>Say Hello</Link>
          </div>
        </AnimatedOnScroll>
      </section>
    </motion.div>
  );
};

export default About;